import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './ContactPopup.css';

const ContactPopup = () => {
    const [showPopup, setShowPopup] = useState(false);
    const history = useHistory();

    useEffect(() => {
        // Show popup after 3 seconds
        const timer = setTimeout(() => {
            setShowPopup(true);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    const handleStay = () => {
        setShowPopup(false);
    };

    const handleChange = (e) => {
        setShowPopup(false);
        e.preventDefault();
    history.push('/contact-us#contact-form-section');
    
    // Scroll to the contact form section after navigation
    setTimeout(() => {
      const element = document.getElementById('contact-form-section');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
}

    if (!showPopup) {
        return null;
    }

    return (
        <div className="contact-popup-overlay">
            <div className="contact-popup">
                <div className="contact-popup-content">
                    <h3 className="contact-popup-title">
                        Need a Hydraulic Solution? Let’s Talk!
                    </h3>
                    <p className="contact-popup-question">
                        Our experts in Ireland are ready to assist with tailored hydraulic services and components.
                        Send us your enquiry now.
                    </p>
                    <div className="contact-popup-buttons">
                        <button
                            className="contact-popup-btn contact-popup-btn-stay"
                            onClick={handleStay}
                        >
                            No, stay.
                        </button>
                        <button
                            className="contact-popup-btn contact-popup-btn-change"
                            onClick={handleChange}
                        >
                            Enquire now.
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactPopup; 